import { hasPermissionByAllIdsAndKeysAndValues as hasPermissionByAllIdsAndKeysAndValuesUtil, hasPermissionByAllIdsAndKeys as hasPermissionByAllIdsAndKeysUtil, hasPermissionByAllIds as hasPermissionByAllIdsUtil, hasPermissionByIdsAndKeysAndValues as hasPermissionByIdsAndKeysAndValuesUtil, hasPermissionByIdsAndKeys as hasPermissionByIdsAndKeysUtil, hasPermissionByIds as hasPermissionByIdsUtil, hasPermissionByWholeStructure as hasPermissionByWholeStructureUtil } from '@gef-ui/cdu-user-v2/utils';
import identity from "ramda/es/identity";
import propOr from "ramda/es/propOr";
import isNilOrEmpty from "ramda-extension/es/isNilOrEmpty";
import { createSelector } from 'reselect';
import { REDUCER_NAME } from '../constants';
/**
 * get cdu user from state
 *
 * @documented
 * @category Selector
 * @example
 *
 *  getCduUser(state)
 *
 */ export const getCduUser = createSelector(propOr({}, REDUCER_NAME), identity);
/**
 * is user already initialized or not
 *
 * @documented
 * @category Selector
 * @example
 *
 *  getIsUserInit(state)
 *
 */ export const getIsCduUserInit = createSelector(getCduUser, (cduUser)=>!isNilOrEmpty(cduUser));
/**
 * get logon of user
 *
 * @documented
 * @category Selector
 * @example
 *
 *  getUserLogon(state)
 *
 */ export const getCduUserLogon = createSelector(getCduUser, propOr(null, 'userLogon'));
/**
 * allowed companies of user
 *
 * @documented
 * @category Selector
 * @example
 *
 *  getUserLogon(state)
 *
 */ export const getAllowedCompanies = createSelector(getCduUser, propOr([], 'allowedCompanies'));
/**
 * get cdu user permissions from state
 *
 * @documented
 * @category Selector
 * @example
 *
 *  getCduUserPermissions(state)
 *
 */ export const getCduUserPermissions = createSelector(getCduUser, propOr({}, 'permissions'));
/**
 * check if user has permissions by all defined ids
 *
 * @documented
 * @category Selector
 * @example
 *
 *  hasPermissionByAllIds(state)([{id: 1},{id: 2}])
 *
 */ export const hasPermissionByAllIds = createSelector(getCduUserPermissions, hasPermissionByAllIdsUtil);
/**
 * check if user has permissions by any defined id
 *
 * @documented
 * @category Selector
 * @example
 *
 *  hasPermissionByIds(state)([{id: 1},{id: 2}])
 *
 */ export const hasPermissionByIds = createSelector(getCduUserPermissions, hasPermissionByIdsUtil);
/**
 * check if user has permissions by all defined id and attribute key
 *
 * @documented
 * @category Selector
 * @example
 *
 *  hasPermissionByAllIdsAndKeys(state)([{id: 1, attributes: [{key: 123}]},{id: 2,attributes: [{key: 123}, {key: 234}]}])
 *
 */ export const hasPermissionByAllIdsAndKeys = createSelector(getCduUserPermissions, hasPermissionByAllIdsAndKeysUtil);
/**
 * check if user has permissions by any defined id and attribute key
 *
 * @documented
 * @category Selector
 * @example
 *
 *  hasPermissionByIdsAndKeys(state)([{id: 1, attributes: [{key: 123}]},{id: 2,attributes: [{key: 123}, {key: 234}]}])
 *
 */ export const hasPermissionByIdsAndKeys = createSelector(getCduUserPermissions, hasPermissionByIdsAndKeysUtil);
/**
 * check if user has permissions by all defined id, attribute key and attribute value
 *
 * @documented
 * @category Selector
 * @example
 *
 *  hasPermissionByAllIdsAndKeysAndValues(state)([{id: 1, attributes: [{key: 123, value: "123"}]}])
 *
 */ export const hasPermissionByAllIdsAndKeysAndValues = createSelector(getCduUserPermissions, hasPermissionByAllIdsAndKeysAndValuesUtil);
/**
 * check if user has permissions by any defined id, attribute key and attribute value
 *
 * @documented
 * @category Selector
 * @example
 *
 *  hasPermissionByIdsAndKeysAndValues(state)([{id: 1, attributes: [{key: 123, value: "123"}]}])
 *
 */ export const hasPermissionByIdsAndKeysAndValues = createSelector(getCduUserPermissions, hasPermissionByIdsAndKeysAndValuesUtil);
/**
 * check if user has permissions by whole structure with following logic.
 * defined only id > check by id
 * defined id, attr key > check by id and key
 * defined id, attr key, attr value > check by all
 *
 * @documented
 * @category Selector
 * @example
 *
 *  hasPermissionByIdsAndKeysAndValues(state)([{id: 2},{id: 1, attributes: [{key: 123, value: "123"}]}])
 *
 */ export const hasPermissionByWholeStructure = createSelector(getCduUserPermissions, hasPermissionByWholeStructureUtil);
